import React, { FC } from 'react';

import cn from '@/utils/cn';

import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';

interface Props {
  title: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  defaultOpen?: boolean;
}

const Collapse: FC<Props> = ({
  title,
  children,
  className,
  defaultOpen = false,
}) => {
  return (
    <>
      <CollapsiblePrimitive.Root
        defaultOpen={defaultOpen}
        className={cn('overflow-hidden rounded-lg', className)}
      >
        <CollapsiblePrimitive.CollapsibleTrigger className="group w-full">
          {title}
        </CollapsiblePrimitive.CollapsibleTrigger>
        <CollapsiblePrimitive.CollapsibleContent
          data-testid="collapse-content"
          className={cn(
            'overflow-hidden data-[state=closed]:animate-collapse data-[state=open]:animate-expand'
          )}
        >
          {children}
        </CollapsiblePrimitive.CollapsibleContent>
      </CollapsiblePrimitive.Root>
    </>
  );
};

export default Collapse;
